import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/global/Layout"
import Seo from "../components/global/SEO"
import Footer from "../components/global/Footer"
import Nav from "../components/global/Nav"
import ParticleHeader from "../components/blocks/ParticleHeader"
import NewsArticle from "../components/blocks/NewsArticle"
import styled from "@emotion/styled"

const Outer = styled.div`
  grid-column: span 3;
  display: grid;
  padding: 64px 0;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
`
const Inner = styled.div`
  color: ${props => props.textColor};
  grid-column: 2 / 3;
  display: grid;
  gap: 32px;
  justify-content: center;
  align-items: center;
`

const NewsPage = ({ data: { allPrismicPost } }) => (
  <Layout>
    <Seo title="News" />
    <Nav />
    <ParticleHeader>News</ParticleHeader>
    <Outer>
      <Inner>
        {allPrismicPost.edges.map(({ node }) => (
          <NewsArticle
            title={node.data.title.text}
            to={node.uid}
            key={node.uid}
          />
        ))}
      </Inner>
    </Outer>
    <Footer />
  </Layout>
)

export const pageQuery = graphql`
  query AllConsumerNews {
    allPrismicPost(sort: { order: DESC, fields: data___date }) {
      edges {
        node {
          data {
            title {
              text
            }
            content {
              text
            }
          }
          uid
        }
      }
    }
  }
`

export default NewsPage
